import ContactForm from './ContactForm'
import { useState } from 'react'
import { useTranslation } from 'next-i18next'

export default function SellerSupport ({ company }) {
  const { t } = useTranslation('plugins')
  const [isActive, setIsActive] = useState(false)

  return (
    <div className={`support ${isActive ? 'support__show' : ''}`}>
      <button
        className="btn btn-primary"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseSupport"
        aria-expanded="false"
        aria-controls="collapseSupport"
        onClick={() => setIsActive(!isActive)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="-0.5 -0.5 24 24"
          height="20"
          width="20"
        >
          <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.90625 9.336083333333335a3.595666666666667 3.595666666666667 0 1 1 4.371916666666667 3.5055833333333335 0.9650416666666666 0.9650416666666666 0 0 0 -0.7781666666666668 0.9343750000000001v1.066625"
            strokeWidth="1"
          ></path>
          <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.5 22.52179166666667c6.086375 0 11.020833333333334 -4.934458333333334 11.020833333333334 -11.020833333333334S17.586375 0.480125 11.5 0.480125 0.4791666666666667 5.414583333333334 0.4791666666666667 11.500958333333333s4.934458333333334 11.020833333333334 11.020833333333334 11.020833333333334Z"
            strokeWidth="1"
          ></path>
          <path
            stroke="#fff"
            d="M11.501916666666668 17.721500000000002a0.23958333333333334 0.23958333333333334 0 1 1 0 -0.4791666666666667"
            strokeWidth="1"
          ></path>
          <path
            stroke="#fff"
            d="M11.501916666666668 17.721500000000002a0.23958333333333334 0.23958333333333334 0 1 0 0 -0.4791666666666667"
            strokeWidth="1"
          ></path>
        </svg>

        <span className="ms-2">
          {t('company_support')}
        </span>
      </button>
      <div
        className="collapse"
        id="collapseSupport"
      >
        <div className="card card-body">
          <ContactForm
            company={company}
            onSend={() => {
              const element = document.getElementById('collapseSupport')
              const collapse = window.bootstrap.Collapse.getInstance(element)

              collapse.hide()
            }}
          />
        </div>
      </div>
    </div>
  )
}
